export const EDIT = "EDIT";
export const REORDER = "REORDER";
export const EDITSAVE = "EDITSAVE";
export const REORDERSAVE = "REORDERSAVE";
export const TOP = "TOP";
export const UP = "UP";
export const SINGULAR = "item";
export const PLURAL = "items";
export const MOVED_DOWN = "moved down";
export const MOVED_UP = "moved up";
export const MOVE_TOP = "moved to top";
export const MOVE_BOTTOM = "moved to bottom";
export const REORDER_INSTRUCTIONS = "Select ALT+w to toggle select mode. Use SPACE to select a row. Select ALT+k for more keyboard instructions";
export const SELECTION_MODE_ENABLED = "Selection mode enabled.";
export const SELECTION_MODE_DISABLED = "Selection mode disabled.";
export const ANNOUNCEMENT_TIMEOUT = 0;
export const CLEAR_ANNOUNCEMENT_TIMEOUT = 250;
export const KEYBOARD_HELP_BTN_DESCRIPTION = "Select ALT+K (Windows) / Option+K (Mac) for keyboard help";
export const KEYBOARD_HELP_CLOSE_ARIA_LABEL = "Close keyboard help dialog";
export const KEYBOARD_HELP_BUTTON = "Keyboard help";
export const KEYBOARD_HELP_HEADER = "Keyboard Help";